import React from 'react';
import {Box} from '@material-ui/core';

export const TabPanel = (props) => {
  const {children, classes, value, index, ...other} = props;

  const panel = classes?.panel ? classes.panel : undefined;
  const box = classes?.box ? classes.box : undefined;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      className={panel}
      {...other}
    >
      <Box p={3} className={box}>
        {children}
      </Box>
    </div>
  );
};

export const TabProps = (index) => {
  return {
    id: `tab-${index}`,
    'aria-controls': `tabpanel-${index}`,
  };
};

export const PanelProps = (value, index) => {
  return {
    value: value,
    index: index
  };
};
